import { BehaviorParameters } from 'rangeConfig/@types';
import { ComponentIds, Vector } from '@inter-ikea-core/core';
import { getMajorityProduct } from '../../shared/utils/frontLayouts';
import { isSameFrontStyleApplied, setFrontStyleSheetVisible } from 'ducks/sheets';
import { isOpenFrame } from 'rangeConfig/platsa/rules/hideMenuRules';
import { ErrorMessages, ProductType, SlidingDoorComponent } from '@inter-ikea-storageone/range';
import { autoFillDoorsAtTarget } from '../utils/autoFillDoors';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const addFrameWithDoorStyle = ({ coreApi, rootState, props, dispatch }: BehaviorParameters) => {
  const {
    products: { inMarket: products }
  } = rootState;

  const isApplied = isSameFrontStyleApplied(rootState);

  let placementResult;
  const product = rootState.products.inMarket.find(p => p.coreProductId === props.coreProductId);
  if (product?.type === ProductType.PAX_CORNER_SOLUTION_ASM) {
    const entity = coreApi.getServices().productManager.createEntity(props.coreProductId);
    if (!entity) return;
    const position = new Vector(1000, 0, 0);
    // Set position to start adding frames in right corner for better lighting conditions
    placementResult = coreApi.placementService.snapToScene(entity, position);
  } else {
    placementResult = coreApi.products.add(props.coreProductId, props.position);
  }

  if (!placementResult.placedEntity) {
    if (!hideNoFramesInSceneErrorMessage(coreApi)) {
      coreApi.emit.onPlacementAttempt(ErrorMessages.NoFramesInScene);
    }
    coreApi.entities.disposeCollidingEntities(placementResult.errors);
    return;
  }

  const addedFrame = placementResult.placedEntity;

  const isFrameOpen = isOpenFrame(coreApi, addedFrame.id);

  const doorsInScene = coreApi.entities.getByComponents([
    ComponentIds.DOOR_COMPONENT_ID,
    SlidingDoorComponent.id
  ]);

  const majorityProductId = getMajorityProduct(doorsInScene);

  const doorProduct = products.find(p => p.coreProductId === majorityProductId);

  const frontProductIsMostlySlidingDoors =
    doorProduct?.type === ProductType.PAX_SLIDING_DOOR_REGULAR_ASM ||
    doorProduct?.type === ProductType.PAX_SLIDING_DOOR_WITH_PANELS_ASM;

  const frames = coreApi.entities.getByComponent(ComponentIds.FRAME_COMPONENT_ID);

  if (frames.length >= 1 && doorProduct && !isFrameOpen) {
    if (isApplied) {
      autoFillDoorsAtTarget(
        doorProduct.coreProductId,
        ['S40301124_ASM', 'S10301125_ASM', 'S20414829_ASM', 'S00414830_ASM'],
        coreApi,
        placementResult.placedEntity,
        products
      );
    } else if (isApplied === undefined && !frontProductIsMostlySlidingDoors) {
      dispatch(setFrontStyleSheetVisible(placementResult.placedEntity || undefined));
    } else if (isApplied === false) return;
  }
};

export default addFrameWithDoorStyle;
